import { NavigateBackLinkWithHistory } from '@exam-center/components';
import { RoomStatus } from '@exam-center/graphql';
import { Chip, Flex, PageHeader, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';

import { useAdminExamLocationDetail } from '../../providers';
import { AdminExamLocationDetailNavigationTabs } from '../admin-exam-location-detail-navigation-tabs';

export default function AdminExamLocationDetailHeader() {
  const { examRoomInfo } = useAdminExamLocationDetail();
  const fullName = [examRoomInfo.updatedUser?.firstname, examRoomInfo.updatedUser?.lastname]
    .filter(Boolean)
    .join(' ');

  const isRetired = examRoomInfo.status === RoomStatus.Retired;

  return (
    <PageHeader
      title={examRoomInfo.building.location.nameTh}
      endAdornment={
        isRetired ? (
          <Chip
            label='ยกเลิกการใช้งาน'
            sx={(theme) => ({
              bgcolor: theme.palette.grey[50],
              border: `1px solid ${theme.palette.grey[500]}`,
              color: theme.palette.grey[700],
              fontWeight: 600,
              fontSize: 14,
              borderRadius: '6px',
              px: 1.5,
              py: 0.25,
            })}
          />
        ) : undefined
      }
      tabs={isRetired ? undefined : <AdminExamLocationDetailNavigationTabs />}
      linkAdornment={<NavigateBackLinkWithHistory fallbackPath='/admin/exam-location/locations' />}
      subtitleSection={
        isRetired ? (
          <Flex sx={{ flex: 1 }}>
            <Text variant='body2' color='text.secondary'>
              วันที่ยกเลิกการใช้งาน: {formatDateTime(examRoomInfo.retiredAt) ?? '-'}
            </Text>
          </Flex>
        ) : (
          <Flex
            sx={{
              justifyContent: 'flex-end',
              flex: 1,
              gap: (theme) => theme.spacing(4),
            }}
          >
            <Text variant='body2' color='text.secondary'>
              Last Updated: {formatDateTime(examRoomInfo.updatedAt) ?? '-'}
            </Text>
            <Text variant='body2' color='text.secondary'>
              By: {fullName.length > 0 ? fullName : '-'}
            </Text>
          </Flex>
        )
      }
    />
  );
}
